// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2qCsj","detailsBorder":"styles_detailsBorder__1_fLp"};